import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    commentsContainer: {
        "& .react-multi-carousel-list": {
            flexWrap: "wrap",
            filter: "drop-shadow(6px 14px 64px rgba(58, 40, 167, 0.1))",
            "@media (max-width: 600px)": {
                overflow: "visible !important",
                margin: "0 -6px"
            }
        },
        "& .react-multi-carousel-track": {

        },
        "& .react-multi-carousel-item": {
            "@media (max-width: 600px)": {
                padding: "0 6px"
            }
        },
        "& .react-multi-carousel-dot-list": {
            position: "static",
            marginTop: 56,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            "& .carousel-dot-item": {
                width: 48,
                height: 48,
                border: "none",
                cursor: "pointer",
                background: "transparent",
                "& img": {
                   borderRadius: "50%"
                },
                "& + .carousel-dot-item": {
                    marginLeft: 12,
                    "@media (max-width: 600px)": {
                        marginLeft: 10
                    }
                },
                "@media (max-width: 600px)": {
                    width: 32,
                    height: 32
                },
                "&.active": {
                    width: 80,
                    height: 80,
                    position: "relative",
                    "&:before": {
                        content: "''",
                        border: "17px solid transparent",
                        borderLeft: "17px solid #FFF",
                        borderTop: "17px solid #FFF",
                        display: "block",
                        position: "absolute",
                        top: -56,
                        left: 40,
                        "@media (max-width: 600px)": {
                            left: 25
                        }
                    },
                    "@media (max-width: 600px)": {
                        width: 64,
                        height: 64
                    },
                    "&:last-child": {
                        "@media (max-width: 600px)": {
                            "&:before": {
                                transform: "rotate(90deg)",
                                left: 0
                            }
                        }
                    }
                }
            }
        }
    },
    commentsTitle: {
        textAlign: "center",
        marginBottom: 80,
        "@media (max-width: 1200px)": {
            textAlign: "left"
        },
        "@media (max-width: 600px)": {
            marginBottom: 40
        }
    },
    commentsCarousel: {
        // overflow: "hidden"
    }
});
